import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function   Mumbaitopandhhharpur() {



  const cardData = {
    keyword: " Mumbai to Pandharpur Akkalkot Tuljapur Cab Booking ",


"headingDescription": "Royal Route Cab offers reliable Mumbai to Pandharpur, Akkalkot, and Tuljapur cab booking services, providing safe, comfortable, and hassle-free travel for pilgrimage journeys across Maharashtra. This sacred trip is ideal for devotees visiting the famous temples of Lord Vitthal in Pandharpur, Shri Swami Samarth in Akkalkot, and Tulja Bhavani in Tuljapur. Our professional drivers and well-maintained vehicles ensure a smooth and peaceful journey covering all major spiritual destinations with comfort and punctuality. We offer flexible travel options including one-way drops, round trips, and customized temple darshan packages based on your itinerary. Our fleet includes sedans, SUVs, Innova, Ertiga, and Tempo Travellers suitable for solo pilgrims, families, and large groups. With transparent pricing, 24/7 availability, and easy booking, Royal Route Cab is your trusted choice for Mumbai to Pandharpur Akkalkot Tuljapur cab service.",

"topPlaces": [
  {
    "title": "Shri Vitthal Rukmini Temple, Pandharpur",
    "description": "Shri Vitthal Rukmini Temple in Pandharpur is one of the most important pilgrimage sites in Maharashtra dedicated to Lord Vitthal, a form of Lord Krishna. Located on the banks of the Chandrabhaga River, it attracts लाखो (lakhs) of devotees every year, especially during Ashadhi Ekadashi. The temple is known for its spiritual energy, long queues during peak seasons, and deep cultural significance in the Warkari tradition. Pilgrims travel from all over Maharashtra, and cab services make the journey comfortable for families and groups visiting for darshan."
  },
  {
    "title": "Shri Swami Samarth Temple, Akkalkot",
    "description": "Akkalkot is a highly revered spiritual town known for Shri Swami Samarth Maharaj, an incarnation of Lord Dattatreya. The temple is a peaceful and powerful spiritual center where devotees come for blessings, meditation, and spiritual guidance. The surroundings are calm and devotional, making it a key stop in pilgrimage cab routes from Mumbai. Visitors often include Akkalkot in multi-temple tours for a complete spiritual experience."
  },
  {
    "title": "Tulja Bhavani Temple, Tuljapur",
    "description": "Tuljapur is home to the famous Tulja Bhavani Temple, one of the 51 Shakti Peethas dedicated to Goddess Bhavani, the family deity of Chhatrapati Shivaji Maharaj. The temple is a major pilgrimage destination in Maharashtra and is known for its powerful spiritual significance, traditional rituals, and historic importance. Devotees from across India visit this temple for blessings, especially during Navratri and festive seasons."
  },
  {
    "title": "Chandrabhaga River, Pandharpur",
    "description": "The Chandrabhaga River flowing through Pandharpur is considered sacred by devotees visiting the Vitthal Temple. Pilgrims take holy dips in the river before darshan, believing it purifies the soul. The riverbanks are filled with devotional activities, especially during major festivals when lakhs of pilgrims gather for spiritual rituals and ceremonies."
  },
  {
    "title": "Pandharpur Wari Route",
    "description": "The Pandharpur Wari is one of Maharashtra’s largest spiritual pilgrimages where devotees called Warkaris walk long distances singing bhajans in devotion to Lord Vitthal. The route from Mumbai and Pune passes through multiple towns and villages, creating a deeply spiritual atmosphere. Many travelers choose cab services for comfortable pilgrimage travel while still experiencing parts of this sacred journey."
  },
  {
    "title": "Akkalkot Math Area",
    "description": "The Akkalkot Math area is a peaceful spiritual zone surrounding the Swami Samarth Temple, filled with ashrams, prayer halls, and devotional spaces. It is a place where devotees spend time in meditation, chanting, and seeking spiritual peace. The calm environment makes it a significant stop in pilgrimage travel itineraries."
  },
  {
    "title": "Tuljapur Hill Surroundings",
    "description": "The hill surroundings of Tuljapur add to the spiritual and natural beauty of the Tulja Bhavani Temple region. Pilgrims often enjoy panoramic views and peaceful surroundings while visiting the temple town. The elevated terrain enhances the divine atmosphere of the pilgrimage experience."
  },
  {
    "title": "Solapur City",
    "description": "Solapur is the nearest major city connecting Pandharpur, Akkalkot, and Tuljapur. It serves as a transit hub for pilgrims traveling across these sacred destinations. The city offers accommodation, food, and transport facilities, making it an important stop during pilgrimage cab journeys."
  },
  {
    "title": "Bhima River Region",
    "description": "The Bhima River region near Pandharpur plays an important role in the geography and spirituality of the area. The river adds to the agricultural richness and cultural heritage of the region, and pilgrims often encounter scenic views while traveling between temple destinations."
  },
  {
    "title": "Temple Corridor Maharashtra",
    "description": "The Maharashtra temple corridor connecting Pandharpur, Akkalkot, and Tuljapur is one of the most popular pilgrimage circuits in the state. It allows devotees to visit multiple holy sites in a single journey, making cab travel the most convenient option for families and group pilgrimages seeking a complete spiritual experience."
  }
],






services: [
  {
    name: "Mumbai to Pandharpur Cab",
    description: "Mumbai to Pandharpur cab service offers a comfortable and spiritual journey to the holy town of Pandharpur. Ideal for devotees visiting Vitthal Rukmini Temple, this service ensures safe and smooth travel. Professional drivers experienced in long-distance routes enhance convenience. It guarantees a peaceful and hassle-free yatra experience."
  },
  {
    name: "Mumbai to Akkalkot Cab",
    description: "Mumbai to Akkalkot cab service provides reliable travel for devotees visiting Shri Swami Samarth Temple. This service is perfect for spiritual trips and family journeys. Comfortable vehicles and experienced drivers ensure a smooth ride. It ensures a stress-free pilgrimage experience."
  },
  {
    name: "Mumbai to Tuljapur Cab",
    description: "Mumbai to Tuljapur cab service offers convenient travel to the famous Tulja Bhavani Temple. Ideal for religious tours, this service ensures safe and comfortable travel. Flexible pickup options and professional drivers enhance the journey. It guarantees a smooth yatra."
  },
  {
    name: "Mumbai to Pandharpur Taxi",
    description: "Mumbai to Pandharpur taxi provides private and flexible travel for devotees. This service includes door-to-door pickup and comfortable rides. Suitable for families and groups. It ensures a peaceful and reliable journey."
  },
  {
    name: "Mumbai to Akkalkot Taxi",
    description: "Mumbai to Akkalkot taxi offers comfortable transportation for long-distance pilgrimage travel. This service is ideal for devotees seeking convenient and safe travel. Professional drivers ensure timely service. It guarantees a smooth journey."
  },
  {
    name: "Mumbai to Tuljapur Taxi",
    description: "Mumbai to Tuljapur taxi service ensures a comfortable ride to one of Maharashtra’s important pilgrimage sites. Clean vehicles and trained drivers enhance safety. Flexible travel options make it convenient. It ensures a hassle-free trip."
  },
  {
    name: "Mumbai to Pandharpur Cab Booking",
    description: "Mumbai to Pandharpur cab booking allows travelers to reserve their yatra vehicle easily. Customers can select vehicle type, pickup location, and travel schedule. Instant confirmation ensures availability. It simplifies pilgrimage planning."
  },
  {
    name: "Mumbai to Akkalkot Taxi Booking Online",
    description: "Mumbai to Akkalkot taxi booking online provides a quick and convenient way to plan your pilgrimage journey. Secure payment and instant confirmation enhance convenience. It ensures hassle-free booking."
  },
  {
    name: "Mumbai to Tuljapur Cab Price",
    description: "Mumbai to Tuljapur cab price varies based on vehicle type, distance, and trip duration. Transparent pricing ensures no hidden charges. Budget and premium options are available. It helps in planning travel expenses efficiently."
  },
  {
    name: "Mumbai to Pandharpur Taxi Fare",
    description: "Mumbai to Pandharpur taxi fare is designed to be affordable and transparent. Fare depends on route, vehicle type, and duration. Customers receive clear pricing details before booking. It ensures cost-effective travel."
  },
  {
    name: "Mumbai to Akkalkot One Way Cab",
    description: "Mumbai to Akkalkot one way cab offers economical travel without return charges. This service is ideal for single-side journeys. Flexible pickup options enhance convenience. It ensures smooth and budget-friendly travel."
  },
  {
    name: "Mumbai to Tuljapur Round Trip Taxi",
    description: "Mumbai to Tuljapur round trip taxi provides complete travel solutions including return journeys. This service is ideal for devotees planning a full pilgrimage trip. Comfortable vehicles and flexible schedules enhance convenience. It ensures a hassle-free experience."
  },
  {
    name: "Mumbai to Pandharpur Innova Cab",
    description: "Mumbai to Pandharpur Innova cab is perfect for families and groups seeking spacious and comfortable travel. Premium seating and smooth performance enhance long journeys. It ensures a comfortable pilgrimage experience."
  },
  {
    name: "Mumbai to Akkalkot Ertiga Cab",
    description: "Mumbai to Akkalkot Ertiga cab offers affordable and spacious travel for small groups and families. Comfortable seating and good mileage make it ideal for long-distance travel. It ensures a pleasant journey."
  },
  {
    name: "Mumbai to Tuljapur Sedan Cab",
    description: "Mumbai to Tuljapur sedan cab is ideal for couples and small families seeking economical travel. Sedans offer smooth rides and comfort for long journeys. Professional drivers ensure safety. It ensures a relaxed trip."
  },
  {
    name: "Pandharpur Akkalkot Tuljapur Yatra Cab from Mumbai",
    description: "Pandharpur Akkalkot Tuljapur yatra cab from Mumbai offers a complete pilgrimage package covering major temples in one trip. This service is ideal for devotees planning a multi-destination yatra. Comfortable vehicles and experienced drivers ensure smooth travel. It guarantees a spiritual and convenient journey."
  },
  {
    name: "Best Temple Tour Cab Mumbai",
    description: "Best temple tour cab Mumbai provides reliable and comfortable travel for religious tours across Maharashtra and beyond. This service includes customized packages for various temples and pilgrimage routes. Professional drivers ensure safe journeys. It guarantees a peaceful and well-organized travel experience."
  }
],

tableData: [
  ["Mumbai to Pandharpur Cab", "Mumbai to Akkalkot Cab"],
  ["Mumbai to Tuljapur Cab", "Mumbai to Pandharpur Taxi"],
  ["Mumbai to Akkalkot Taxi", "Mumbai to Tuljapur Taxi"],
  ["Mumbai to Pandharpur Cab Booking", "Mumbai to Akkalkot Taxi Booking Online"],
  ["Mumbai to Tuljapur Cab Price", "Mumbai to Pandharpur Taxi Fare"],
  ["Mumbai to Akkalkot One Way Cab", "Mumbai to Tuljapur Round Trip Taxi"],
  ["Mumbai to Pandharpur Innova Cab", "Mumbai to Akkalkot Ertiga Cab"],
  ["Mumbai to Tuljapur Sedan Cab", "Pandharpur Akkalkot Tuljapur Yatra Cab from Mumbai"],
  ["Best Temple Tour Cab Mumbai", "Mumbai to Pandharpur Cab"]
],


whychoose: [
  {
    WhyChooseheading: "Complete Pandharpur Akkalkot Tuljapur Darshan Tour",
    WhyChoosedescription: "Royal Route Cabs offers a well-planned Mumbai to Pandharpur, Akkalkot, and Tuljapur cab booking for a comfortable and spiritual yatra."
  },
  {
    WhyChooseheading: "Experienced Pilgrimage Route Drivers",
    WhyChoosedescription: "Our drivers are highly experienced in handling temple routes and long-distance travel, ensuring safe and smooth darshan trips."
  },
  {
    WhyChooseheading: "Customizable Multi-Day Tour Packages",
    WhyChoosedescription: "We provide flexible 2 to 4 day darshan packages covering Pandharpur Vitthal Temple, Akkalkot Swami Samarth, and Tuljapur Bhavani Mata."
  },
  {
    WhyChooseheading: "Transparent Pricing with No Hidden Charges",
    WhyChoosedescription: "Royal Route Cabs provides clear pricing including tolls, driver allowance, and full trip cost with no hidden charges."
  },
  {
    WhyChooseheading: "Comfortable & Well-Maintained Vehicles",
    WhyChoosedescription: "All vehicles are fully air-conditioned, regularly serviced, and maintained for a comfortable long-distance journey."
  },
  {
    WhyChooseheading: "24/7 Cab Service Availability",
    WhyChoosedescription: "Our Mumbai to Pandharpur Akkalkot Tuljapur cab service operates 24/7 for flexible travel planning."
  },
  {
    WhyChooseheading: "Multiple Vehicle Options for Groups",
    WhyChoosedescription: "We offer sedan cars, SUVs like Ertiga and Innova, premium Innova Crysta, and Tempo Travellers for family and group pilgrimage travel."
  },
  {
    WhyChooseheading: "Trusted Religious Travel Service",
    WhyChoosedescription: "Royal Route Cabs is trusted by devotees for Mumbai to temple darshan trips due to reliable service and experienced drivers."
  }
]

};

const faqData = [
  { question: "Do you provide Mumbai to Pandharpur Akkalkot Tuljapur cab service?", answer: "Yes, Royal Route Cabs offers complete darshan cab packages from Mumbai covering all three temples." },
  { question: "How many days are required for this trip?", answer: "Usually 2 to 4 days are required depending on your travel plan and darshan schedule." },
  { question: "Which temples are covered in this tour?", answer: "The tour includes Pandharpur Vitthal Temple, Akkalkot Swami Samarth Temple, and Tuljapur Bhavani Mata Temple." },
  { question: "Is cab service available 24 hours?", answer: "Yes, our cab service operates 24/7 for flexible travel." },
  { question: "Which vehicles are available?", answer: "We offer sedan cars, SUVs like Ertiga and Innova, Innova Crysta, and Tempo Travellers." },
  { question: "Can I customize the travel plan?", answer: "Yes, we provide fully customizable darshan packages." },
  { question: "Are vehicles air-conditioned?", answer: "Yes, all vehicles are fully air-conditioned for comfortable travel." },
  { question: "Do you provide doorstep pickup?", answer: "Yes, we offer pickup from home, hotel, and airport anywhere in Mumbai." },
  { question: "Is advance booking required?", answer: "Advance booking is recommended especially during festival and peak seasons." },
  { question: "Are vehicles sanitized regularly?", answer: "Yes, all vehicles are cleaned and sanitized regularly for passenger safety." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Shrikant More",
    feedback: "The Mumbai to Pandharpur, Akkalkot, Tuljapur trip with Royal Route Cabs was spiritually fulfilling and very comfortable. The journey was well-planned with a smooth driving experience throughout.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Varsha Deshpande",
    feedback: "Excellent cab service for our pilgrimage tour from Mumbai to Pandharpur, Akkalkot, and Tuljapur. The ride was clean, safe, and made the long journey very relaxing.",
    rating: 5
  }
];












  const Images = [
    { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cabs" },
    { place: "/images/keyword/2.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
    { place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
    { place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
    { place: "/images/keyword/5.jpg", text: "Mumbai Nashik Cab", link: "Mumbai-Nashik-Cab" },
    { place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
    { place: "/images/keyword/7.jpg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
    { place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
    { place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
    { place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
    { place: "/images/keyword/11.jpg", text: "Mumbai to 5 Jyotirlinga cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
    { place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
    { place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
    { place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
    { place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
    { place: "/images/keyword/16.jpg", text: "Mumbai to Matheran cab", link: "Mumbai-to-Matheran-Cab" },
    { place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Cab-Booking-Dhule" },
    { place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
    { place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
    { place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
    { place: "/images/keyword/21.jpg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
    { place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
    { place: "/images/keyword/23.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "Mumbai-to-Narmada-Parikrama-Cab-Booking" },
    { place: "/images/keyword/24.jpg", text: "Mumbai to Baroda Cabs", link: "Mumbai-to-Baroda-Cabs" },
    { place: "/images/keyword/25.jpg", text: "Mumbai to Daman taxi", link: "Mumbai-to-Daman-Taxi" },
    { place: "/images/keyword/26.jpg", text: "Mumbai to Vapi cab", link: "Mumbai-to-Vapi-Cab" },
    { place: "/images/keyword/27.jpg", text: "Mumbai to Bangalore cab", link: "Mumbai-to-Bangalore-Cab" }
  ];







const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mumbai to Pandharpur Akkalkot Tuljapur Cab Booking",
  "image": "https://www.royalroutecabs.com/assets/images/mumbai-temple-yatra-cab.jpg", // replace if needed
  "description": "Book Mumbai to Pandharpur, Akkalkot, and Tuljapur cab service with Royal Route Cabs for comfortable and safe temple yatra travel. Available for one-way and round-trip packages with sedan, SUV, Innova, and Ertiga vehicles. 24x7 reliable service for pilgrimage tours.",
  "brand": {
    "@type": "Brand",
    "name": "Royal Route Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.7",
    "ratingCount": "3200",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "8999", // approximate package price (adjust if needed)
    "availability": "https://schema.org/InStock",
    "url": "https://www.royalroutecabs.com/mumbai-temple-yatra-cab"
  }
};







  return (
    <div>
<Helmet>
  <title>Mumbai to Pandharpur Akkalkot Tuljapur Cab | Call:- +91 9529877342 | Best Outstation Cab Service</title>

  <meta
    name="description"
    content="Book Mumbai to Pandharpur, Akkalkot & Tuljapur cab with Royal Route Cabs. Best temple tour taxi service with safe drivers, affordable packages, and comfortable travel options."
  />

  <meta
    name="keywords"
    content="mumbai to pandharpur cab, mumbai to akkalkot cab, mumbai to tuljapur cab, mumbai to pandharpur taxi, mumbai to akkalkot taxi, mumbai to tuljapur taxi, mumbai to pandharpur cab booking, mumbai to akkalkot taxi booking online, mumbai to tuljapur cab price, mumbai to pandharpur taxi fare, mumbai to akkalkot one way cab, mumbai to tuljapur round trip taxi, mumbai to pandharpur innova cab, mumbai to akkalkot ertiga cab, mumbai to tuljapur sedan cab, pandharpur akkalkot tuljapur yatra cab from mumbai, best temple tour cab mumbai"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

      <div
        className="breadcrumb-wrapper section-padding bg-cover"
        style={{ backgroundImage: "url('/img/breadcrumb-bg.jpeg')" }}
      >
        <div className="container-fluid">
          <div className="page-heading">
            <h1 className="text-center">{cardData.keyword}</h1>
          </div>
        </div>
      </div>














      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/48.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Royal Route Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>


              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    {/* <div className="service-icon">
                      🚗
                    </div> */}
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


          <div className="keyword-grid">
  {cardData.tableData.flat().map((keyword, index) => (
    <div key={index} className="keyword-item">
      <span className="keyword-bullet">-</span>
      {keyword}
    </div>
  ))}
</div>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title text-white">
                  Why Choose <span>Royal Route Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Royal Route Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title=""
                          subtitle=""
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919529877342" className="pc-call">+91 9529877342</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919529877342"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp"></i> WhatsApp
                      </a>
                      <a href="tel:+919529877342" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@royalroutecabs.com" className="pc-email">
                      booking@royalroutecabs.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-geo-alt-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Royal Route Cab</strong><br />
                      Shop Number 57, Prabhat Colony Opp. Panbai International School Vimladevi Road,Santacruz(E) Mumbai Maharashtra-400055.


                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Mumbaitopandhhharpur;